import { render, staticRenderFns } from "./MobileMegaMenu.vue?vue&type=template&id=dd113ef2&"
import script from "./MobileMegaMenu.vue?vue&type=script&lang=js&"
export * from "./MobileMegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileMegaMenu.vue?vue&type=style&index=0&id=dd113ef2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports